<bw-bui-tile-legacy>
  <bui-tile-card-legacy (click)="cellClick($event)" cardBackground="white" tilePadding="8px">
    <bw-bui-row-legacy rightIconName="chevron_right" rightIconColor="var(--brand)">
      <div class="row-content">
        <div class="flex-row">
          <bw-avatar avatarStyle="image" imageURL="./assets/emoney-avatar.png"></bw-avatar>
          <typography-legacy text-small-semibold class="ml-sm">{{ 'SURVEY_CHOICE_MONEY_EMERGENCY' | translate }}</typography-legacy>
        </div>
      </div>
    </bw-bui-row-legacy>
  </bui-tile-card-legacy>
</bw-bui-tile-legacy>
